import { Molecule, wrap } from "AppReact";
import styled from "styled-components";
import { SecondaryTextSm } from "atoms";
import { Mt2 } from "wrappers";
import { Lable } from "./atoms";

const template = styled.div``;

export default Molecule({
  template,
  type: "",
  atoms: [
    {
      component: Lable,
      name: "Label",
      displayValue: ({ label }) => label ?? "",
    },
    {
      component: wrap(SecondaryTextSm, Mt2),
      name: "Content",
      displayValue: ({ content }) => content ?? "",
    },
  ],
});
